// web/src/api/auth/AuthAPI.ts
import { AxiosInstance, AxiosResponse } from 'axios';

import { UserProfile } from 'models/UserProfile';
import { ResetPasswordPayload } from 'types/authTypes';

import SSOService from './SSOService';

export default class AuthAPI {
  client: AxiosInstance;
  sso: SSOService;

  constructor(client: AxiosInstance) {
    this.client = client;
    this.sso = new SSOService(client);
  }

  login({ userName, password }: { userName: string; password: string }) {
    return this.client.post('/authentication/login', {
      userName,
      password,
    });
  }

  logout() {
    return this.client.get('/authentication/logout');
  }

  resetPassword({ userName, newPassword }: ResetPasswordPayload): Promise<
    AxiosResponse<{
      message: string;
      reset_required: boolean;
      user: UserProfile;
    }>
  > {
    return this.client.post('/authentication/reset-password', {
      userName,
      newPassword,
    });
  }

  verifySession() {
    return this.client.get('/authentication/session-status');
  }
}
